import Component from '@glimmer/component';

interface Args {
	type: string;
	item?: string;
	itemCount?: number;
}

export default class SkeletonScreenComponent extends Component<Args> {
	get typeClass() {
		return `type-${this.args.type}`;
	}

	get itemClass() {
		let cl = '';
		if (this.args.item) {
			cl = `items-${this.args.item}`;
		}
		return cl;
	}

	get isTable() {
		return this.args.type === 'table';
	}

	get isTiles() {
		return this.args.type === 'tiles';
	}

	get isGraph() {
		return this.args.type === 'graph';
	}

	get flexSize() {
		return this.args.item;
	}

	get itemCount() {
		let count;

		if (this.args.itemCount) {
			count = this.args.itemCount;
		} else if (this.isTable) {
			count = 5;
		} else {
			switch (this.args.item) {
				case 'board':
					count = 12;
					break;
				case 'goal':
					count = 8;
					break;
				case 'team':
					count = 4;
					break;
				default:
					count = 3;
					break;
			}
		}

		return count;
	}

	get fakeCount() {
		let count;

		switch (this.args.item) {
			case 'board':
				count = 7;
				break;
			case 'goal':
				count = 8;
				break;
			case 'team':
				count = 4;
				break;
			default:
				count = 0;
				break;
		}

		return count;
	}

	get itemsToShow() {
		return new Array<undefined>(this.itemCount);
	}

	get fakesToShow() {
		return new Array<undefined>(this.fakeCount);
	}
	<template>
		<div class="skeleton-screen {{this.typeClass}} {{this.itemClass}}">
			{{#if this.isTable}}

				<table class="bigtable bigtable--no-sticky-header skeleton-table">
					<thead>
						<tr>
							<th><span class="skeleton-shape skeleton-shape--header"></span></th>
							<th><span class="skeleton-shape skeleton-shape--header"></span></th>
							<th><span class="skeleton-shape skeleton-shape--header"></span></th>
							<th class="skeleton-table__optional">
								<span class="skeleton-shape skeleton-shape--header"></span>
							</th>
							<th class="skeleton-table__optional">
								<span class="skeleton-shape skeleton-shape--header"></span>
							</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{{#each this.itemsToShow}}
							<tr>
								<td>
									<div class="skeleton-cell">
										<span class="skeleton-shape skeleton-shape--avatar"></span>
										<span class="skeleton-stack">
											<span
												class="skeleton-shape skeleton-shape--title"
											></span>
											<span
												class="skeleton-shape skeleton-shape--subtitle"
											></span>
										</span>
									</div>
								</td>
								<td>
									<span class="skeleton-stack">
										<span class="skeleton-shape skeleton-shape--text"></span>
										<span class="skeleton-shape skeleton-shape--text"></span>
									</span>
								</td>
								<td>
									<span class="skeleton-shape skeleton-shape--text-wide"></span>
								</td>
								<td class="skeleton-table__optional">
									<span class="skeleton-shape skeleton-shape--pill"></span>
								</td>
								<td class="skeleton-table__optional">
									<span class="skeleton-shape skeleton-shape--pill-wide"></span>
								</td>
								<td class="skeleton-table__action">
									<span class="skeleton-shape skeleton-shape--button"></span>
								</td>
							</tr>
						{{/each}}
					</tbody>
				</table>

			{{else if this.isTiles}}

				<div class="flex-ct flex-ct--size-{{this.flexSize}}">

					{{#each this.itemsToShow}}
						<div class="item flex-item"></div>
					{{/each}}

					{{#each this.fakesToShow}}
						<div class="item flex-item flex-item--fake"></div>
					{{/each}}

				</div>

			{{else if this.isGraph}}

				<div class="item"></div>

			{{/if}}
		</div>
	</template>
}
